import { memo } from 'react';
import { IconProps } from './iconType';

export const HamIcon = memo(({ size, color }: IconProps) => {
  return (
    // export된 svg가 있다면 => 코드창에 열어서 있는 코드 아래 형식처럼 수정하기
    // 디자인 파일에서 svg가 있다면 => svg 코드 복사해서 아래 형식처럼 수정하기
    // xmlns 속성은 제거
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
      <path
        d="M7 8H25V10H7V8ZM7 15H25V17H7V15ZM7 22H25V24H7V22Z"
        fill={color}
      />
    </svg>
  );
});

HamIcon.displayName = 'HamIcon';
